import { render, staticRenderFns } from "./bdd-applications.vue?vue&type=template&id=b8c3769e"
import script from "./bdd-applications.vue?vue&type=script&lang=js"
export * from "./bdd-applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports